import { render } from "./CoinTransactionsList.vue?vue&type=template&id=1cfcf946"
import script from "./CoinTransactionsList.vue?vue&type=script&lang=js"
export * from "./CoinTransactionsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__